import React, { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'saloni_post_login_welcome';

/** Call after a successful sign-in, before navigating away from `/login`. */
export function queuePostLoginWelcome(displayName) {
  if (typeof window === 'undefined') return;
  const name = String(displayName || '').trim();
  sessionStorage.setItem(STORAGE_KEY, name || 'there');
}

export default function PostLoginWelcomeToast() {
  const location = useLocation();
  const [toast, setToast] = useState(null);

  useLayoutEffect(() => {
    const path = location.pathname;
    if (path !== '/admin' && path !== '/account') return;

    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    sessionStorage.removeItem(STORAGE_KEY);
    const name = raw.slice(0, 120);
    setToast({ name });
    const timer = window.setTimeout(() => setToast(null), 5200);
    return () => window.clearTimeout(timer);
  }, [location.pathname]);

  if (!toast) return null;

  return (
    <div
      className="saloni-welcome-toast alert alert-success border-0 shadow py-2 px-3 pe-4 d-flex align-items-center gap-2"
      role="status"
      aria-live="polite"
    >
      <span className="small mb-0">
        Welcome back{toast.name ? (
          <>
            , <strong>{toast.name}</strong>
          </>
        ) : null}
        .
      </span>
      <button
        type="button"
        className="btn-close btn-close-sm ms-auto"
        aria-label="Dismiss"
        onClick={() => setToast(null)}
      />
    </div>
  );
}
